import { mutate } from 'swr'
import { useState } from 'react'
import { Delete_Exam } from '@graphql/mutations'
import { Single_Book, Single_Section } from '@graphql/queries'
import { useApi } from '@hooks/useApi'
import { useContext } from 'react'
import { AppContext } from '@state/context'

const useDeleteExam = () => {
  const [state] = useContext(AppContext)
  const {
    app: { currentSection, currentEditBookObject },
  } = state

  const [isPosting, setIsPosting] = useState(false)
  const { postMutation } = useApi()

  const post = async (data, successMessage, errorMessage) => {
    setIsPosting(true)

    const res = await postMutation(
      data,
      Delete_Exam,
      successMessage ? successMessage : 'Testet är raderat.',
      errorMessage ? errorMessage : 'Nåt gick fel när testet skulle raderas.',
      async () => {
        if (currentEditBookObject) {
          await mutate([Single_Book, currentEditBookObject.id]) // refetch current book
        }
        if (currentSection) {
          await mutate([Single_Section, currentSection.id]) // refetch single section
        }
      }
    )

    setIsPosting(false)
    return res
  }

  return {
    post,
    isPosting,
  }
}

export { useDeleteExam }
